module.exports = __webpack_public_path__ + "img/146.afe0369b.jpg";